import countryList from "react-select-country-list";

export const getCountryCode = (country: string): string => {
  const wantedCountry = countryList()
    .getData()
    .filter((countryData) => countryData.label == country);
  if (wantedCountry.length == 0) return "";
  return wantedCountry[0].value;
};
